import React from 'react';
import { getAmountWithCurrency } from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../../enums';

export const WinNotification = ({ t, winData }) => {
  return (
    <div className='min-max-popup-holder'>
      <div className='popups-holder'>
        {winData.map(({ winAmount, odd, id }) => (
          <div key={id} className='min-max-win-popup'>
            <div className='min-max-win-popup-row'>
              <p className='min-max-win-popup-row-text'>
                {t(globalTranslationKeys.YouHaveCashedOut)}
              </p>
              <p className='popup-row-num-tex'>x{odd}</p>
            </div>
            <div className='min-max-win-popup-row'>
              <p className='min-max-win-popup-row-text'>{t(globalTranslationKeys.YourWin)}</p>
              <p className='popup-row-num-tex'>
                {getAmountWithCurrency({
                  amount: winAmount.toFixed(2),
                })}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
